import React from "react";
import { Box, Typography, Button } from "@mui/material";
import wrongQr from '../../assets/wrongQr.png'
import DaalchiniLogo from '../../assets/dalchini_icon.png'
import backArrow from '../../assets/backArrow.png'
import { useNavigate } from "react-router-dom";

const AlreadyScanned = (   ) => {
  const navigate=useNavigate()
  const onContinue=()=>{
    navigate(`/`)
  }
  const MyHeader = ({ handleBack }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      p={2}
      sx={{
        background: "#fae14b",
        position: "fixed",
        width: "100%",
        zIndex: 999,
      }}
    >
         <Box
        component="img"
        src={backArrow}
        alt="Logo"
        sx={{ width: 27, height: 20, ml: 1 }}
        onClick={onContinue}
      />

      {/* Add Image */}
      <Box
        component="img"
        src={DaalchiniLogo}
        alt="Logo"
        sx={{ width: 100, height: 40, ml: 1 }}
      />

   
    </Box>
  );
};
  return (
    <>
    <MyHeader/>
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
        textAlign: "center",
        px: 2,
      }}
    >
      {/* Image */}
      <img
        src={wrongQr}
        alt="Scanned"
        style={{
          width: "240px",
          height: "auto",
          marginBottom: "20px",
        }}
      />

      {/* Title */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          color: "#000",
          mb: 1,
        }}
      >
        Already Scanned
      </Typography>

      {/* Subtitle */}
      <Typography
        variant="body1"
        sx={{
          color: "#555",
          fontSize: "15px",
          maxWidth: "340px",
          mb: 4,
          lineHeight: 1.4,
        }}
      >
        This QR Code Has Already Been Scanned By You.
        <br />
        Continue Here To Create A New Order
      </Typography>

      {/* Continue Button */}
      <Button
        onClick={onContinue}
        variant="contained"
        sx={{
          backgroundColor: "#00C853",
          color: "#fff",
          fontWeight: 600,
          textTransform: "none",
          px: 5,
          py: 1.2,
          borderRadius: "25px",
          boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
          "&:hover": {
            backgroundColor: "#00b34a",
          },
        }}
      >
        Continue
      </Button>
    </Box>
    </>
  );
};

export default AlreadyScanned;
